import {createAsyncThunk} from "@reduxjs/toolkit";
import {saveSearch} from "../savedSearchService";

// Create a thunk that will be called when the component mounts
export const saveSearchThunk = createAsyncThunk(
    'enhancedSearch/saveSearchThunk',
    async ({ searchTerm, searchUrl, remove }, {
        getState,
    }) => {
        try {
            console.log('saveSearchThunk called with:', { searchTerm, searchUrl, remove });
            return saveSearch(getState().searchMetadataSlice.savedSearches, {searchTerm, searchUrl}, remove);
        } catch (error) {
            return { };
        }
    }
);